import React from 'react';
import { Quote } from 'lucide-react';
import { testimonials } from '../data/mock';
import { Card, CardContent } from './ui/card';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-[#0a0a0b]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              <span className="text-[#06b6d4]">Testimonials</span> & Recommendations
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#06b6d4] to-[#10b981] mx-auto mb-4"></div>
            <p className="text-[#a3a3a3] max-w-2xl mx-auto">
              What people I've worked with have to say about my work and collaboration
            </p>
          </div>

          {/* Testimonials Grid */}
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <Card
                key={testimonial.id}
                className="bg-[#121214] border-[#1f1f23] hover:border-[#06b6d4] transition-all duration-300 hover:scale-105 group"
              >
                <CardContent className="p-6">
                  {/* Quote Icon */}
                  <div className="mb-4">
                    <Quote size={32} className="text-[#06b6d4] opacity-50" />
                  </div>

                  {/* Testimonial Text */}
                  <p className="text-[#a3a3a3] mb-6 leading-relaxed italic">
                    "{testimonial.text}"
                  </p>

                  {/* Author Info */}
                  <div className="flex items-center gap-4 pt-4 border-t border-[#1f1f23]">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full border-2 border-[#10b981] group-hover:scale-110 transition-transform duration-300"
                    />
                    <div>
                      <h4 className="text-white font-semibold">{testimonial.name}</h4>
                      <p className="text-[#06b6d4] text-sm">{testimonial.position}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
